async function updateCartDrawer() {
  const res = await fetch("/?section_id=header");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}
$(function(){
  $(document).on('click','.add-to-cart,.js-qty__adjust',function(){
    console.log('rffg')
    setTimeout(function(){
updateCartDrawer()
    },1000)
  })
})